/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {SingleColorIconProps} from '../IconTypes';

/**
 * ![PinUprightIcon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAAA+klEQVR4nO2UPU7DQBCFTY9yHjcUKJbsgn0zLrwzEjUSHeIA4QpwGoRER3KEUOLULqOAZAkkI1MQaNifLBEFT3ql37c7O89Ztm8Zkg6sQ4wNSecGsD7GAsCydALAeh4P0DOfKR0AegnW1juY5AksF+O3fg/x/UbDTw4O/AcEydQ2d+5+bfMsRkRyBJa1x+4/n5BMg8IBe2xINwH7/0JkS8+T2xKsfUTJei+IYV3t0OTWPZ748MGreCCZR/9NWR+yPyuwXBvW+w+T3qQHkN5uRyF3yQGGZPalXFfJAYAtPgGwRXJA0zSHYH01pG9VdTpJDhgF0sXoXwmP1TvHmZW72sg46AAAAABJRU5ErkJggg==)
 */
export const PinUprightIcon = ({
  size = 'md',
  width,
  height,
  color = tokens.colors.INTERACTIVE_NORMAL,
  colorClass = '',
  ...props
}: SingleColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <path
        fill={typeof color === 'string' ? color : color.css}
        d="M16.91 5C18.61 5 20 3.48 20 1.6v-.1a.5.5 0 0 0-.5-.5h-15a.5.5 0 0 0-.5.5v.1C4 3.49 5.38 5 7.09 5H8v4.35l-3.39 3.26A2 2 0 0 0 4 14.05V15a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1v-.95a2 2 0 0 0-.61-1.44L16 9.35V5h.91ZM13.37 17.25c.33 0 .56.3.5.61l-1.08 4.75a.5.5 0 0 1-.49.39h-.6a.5.5 0 0 1-.49-.39l-1.07-4.75a.5.5 0 0 1 .49-.61h2.74Z"
        className={colorClass}
      />
    </svg>
  );
};
